import React from "react";

const SliderCard = (props) => {
	const { title, image, caption, link , url: imageSrc, alt} = props;

	return (
		<figure className="slider-card">	
			<div className="slider-card__image">
				<img src={imageSrc} alt={alt} />
			</div>
			
			{caption && (
				<figcaption className="slider-card__caption">{caption}</figcaption>
			)}
			
		</figure>
	);
};

export default SliderCard;

